/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {DriverObject} from "../models/driver-object";
import {DriverObjectService} from "../services/driver-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {PAGING_ITEMS_PER_PAGE} from "../app-constants";
import { PagedResults } from "app/models/paged-results";

@Injectable()
//@Input() KHT - using the @Input() tag breaks certain resolvers after Angular 12 update
export class DriverObjectsPagingResolver implements Resolve<PagedResults<DriverObject>> {

  constructor(
    private mDriverObjectService: DriverObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<PagedResults<DriverObject>> {
    try {
      return await this.mDriverObjectService.getAllDriverObjectsForPaging(0, PAGING_ITEMS_PER_PAGE, "ASC", "");
    } catch (error) {
      console.error("Problem resolving Driver Objects... Error: " + error, error);
    }
  }

}
